import React from "react";

import "./Loading.css";

import loadingIcon from "assets/images/loading-icon.gif";

export default props => (
  <div className="loading">
    <img src={loadingIcon} alt="loading" className="loading__icon" />
  </div>
);



// WEBPACK FOOTER //
// ./src/components/Loading/Loading.js